<template>
    <div class="dialog-body d-flex flex-column h-100">
        <div class="flex flex-grow-1 d-flex flex-column dialog-content overflow-auto">
            <div>
                <div id="dgs-template"  class="d-flex flex-wrap template_filter_container">
                    <div class="search-bar-gray d-flex" style=" min-width: 26.25rem;">
                        <v-btn class="p-0" @click="searchTemplates()"><v-icon>mdi-magnify</v-icon></v-btn>
                        <v-text-field id="search" v-model="search" solo :label="SearchLabel" @keydown.enter="searchTemplates()"></v-text-field>
                        <v-btn class="p-0" v-if="search.length" @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_TemplateType") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu1">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (templateType == -1 ? $t("res_Label_Select") : templateTypes.find(x => x.id ==
                                        templateType).name) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in templateTypes" :key="index" v-model="templateType">
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.id"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearByTemplateType">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500" @click="searchByTemplateType">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_Language") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu2" offset>
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (language == -1 ? $t("res_Label_Select") : language) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in languages" :key="index" v-model="language">
                                    <v-radio
                                        :label="chooseLanguageLabel(item.name) + ' (' + item.count + ')'"
                                        :value="item.name == 'EN' ? 'EN' : (item.name == 'AR' ? 'AR' : item.name)"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByLanguage">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500" @click="searchTemplatesByLanguage">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_SignatureRequired") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu3">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (signatureCount == -1 ? $t("res_Label_Select") : signatureCount) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in singatureCounts" :key="index" v-model="signatureCount" v-if="item.count > 0">
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.name"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesBySignatruesCount">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500" @click="searchTemplatesBySignatruesCount">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter" v-if="constants.client_version_Id != 'DGS'">
                        <label>{{ $t("res_Label_Tags") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu4">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (tag == -1 ? $t("res_Label_Select") : tag) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in tags" :key="index" v-model="tag">
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.name"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByTags">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500" @click="searchTemplatesByTags">{{$t("res_ButtonText_Apply")}}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter" v-if="constants.client_version_Id != 'DGS'">
                        <label>{{ $t("res_Label_Privacy") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu5">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (privacy == -1 ? $t("res_Label_Select") : privacies.find(x => x.id == privacy).name) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in privacies" :key="index" v-model="privacy">
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.id"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByPrivacy">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500" @click="searchTemplatesByPrivacy">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="d-none">
                        <v-btn class="light-clear-btn" icon @click="clearAllFilters()"><v-icon>mdi-delete-empty-outline</v-icon></v-btn>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-grow-1 overflow-auto m-0 divided_row">
				<div class="col-lg-6 p-0 left-side">
                    <div id="dgs-template" class="h-100 overflow-auto">

                        <h2 class="main-text-large pl-6 pr-6 chose-template-fav" style="color: #667593!important;">{{ $t("res_CardHeaders_FavoriteCorrespondences")}} ({{ favoriteCorrespondences.length }})</h2>
                        <div class="grid-2-items">
                            <div v-for="(item, i) in favoriteCorrespondences" :key="i">
                                <v-card  id="dgs-card" class="bg-white template_card pb-0 dgs-min-height-120px" @click="handleTemplateClicked(item, true)"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px;">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style=" margin-bottom:33px" >
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.favoriteName }}</h3>
                                            <p class="action-label-new ">{{ item.name }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip dark style="background:transparent; " class="float-right p-0"
                                                @click="openRemoveFavoriteDialog(item.documentId)"> <!-- change it to favorite delete -->
                                                <v-icon style="color: goldenrod;">mdi-star-circle</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex">
                                        <v-chip class="light-blue-dgs">{{ item.language }}</v-chip>
                                        <v-chip  class="blue-dgs">{{  item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>

                                    <v-dialog v-model="removeFavoriteDialog" content-class="small-dialog" width="500" height="350">
                                        <v-card>
                                            <v-card-title>
                                                {{ $t("res_Label_Alert") }}
                                            </v-card-title>
                                            <div class="card-body">
                                                <h3>{{ $t("res_Msgs_EnsureRemoveFavorite") }}</h3>

                                            </div>
                                            <v-card-actions class="gap-2 sticky-actions">
                                                <v-spacer></v-spacer>
                                                <v-btn color="primary" @click="RemoveFromDocumentFavorites(item.documentId)">{{ $t("res_ButtonText_Continue") }}</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-card>
                            </div>
                        </div>

						<h2 class="main-text-large pl-6 pr-6 chose-template-fav" style="color: #667593!important;">{{ $t("res_CardHeaders_Favorites")}} ({{ favourite_templates.length }})</h2>
                        <div class="grid-2-items">
                            <div v-for="(item, i) in favourite_templates" :key="i">
                                <v-card  id="dgs-card" class="bg-white template_card pb-0 d-grid dgs-min-height-120px" @click="handleTemplateClicked(item)" @dblclick="createTemplate()"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px;">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style=" margin-bottom:10px" >
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.name }}</h3>
                                            <p class="action-label-new ">{{ getShortDescription(item.descriptionEn) }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip dark style="background:transparent" class="float-right p-0" @click="RemoveFromFavorites(item.id)">
                                                <v-icon style="color: goldenrod;">mdi-star-circle</v-icon>
                                            </v-chip>
                                            <v-chip dark style="background:transparent" class="float-right view-icon p-0" @click="scrollIntoViewer()">
                                                <v-icon small color="blue">mdi-eye</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex">
                                        <v-chip class="light-blue-dgs">{{ item.language }}</v-chip>
                                        <v-chip class="light-blue-dgs" v-if="item.extraInfoCount > 0" v-tooltip="item.extraInfoText">{{ ' + ' + item.extraInfoCount }}</v-chip>
                                        <v-chip class="blue-dgs">{{  item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>

						<h2 class="main-text-large pl-6 pr-6" style="color: #667593!important;">{{ $t("res_CardHeaders_All")}} ({{ templates.length }})</h2>
                        <div class="grid-2-items">  
                            <div v-for="(item, i) in templates" :key="i">
                                <v-card id="dgs-card" class="on-hover-display bg-white template_card dgs-card-selected d-grid dgs-min-height-120px" @click="handleTemplateClicked(item)" @dblclick="createTemplate()"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style="gap:10px; margin-bottom: 33px">
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.name }} </h3>
                                            <p class="action-label-new ">{{ item.descriptionEn }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip dark color="white" class="float-right p-0 on-hover-display-item " style="height:24px"
                                                    @click="addToFavorites(item.id)">
                                                <v-icon style="color: goldenrod;">mdi-star-circle</v-icon>
                                            </v-chip>
                                            <v-chip dark style="background:transparent" class="float-right view-icon p-0"
                                                @click="scrollIntoViewer()">
                                                <v-icon small color="blue">mdi-eye</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex m-0 p-0">
                                        <v-chip dark class="light-blue-dgs" >{{ item.language }}</v-chip>
                                        <v-chip dark class="light-blue-dgs"  v-if="item.extraInfoCount > 0" v-tooltip="item.extraInfoText">{{ ' + '+ item.extraInfoCount }}</v-chip>
                                        <v-chip dark class="blue-dgs">{{ item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </div>
				<div class="col-lg-6 right-side pt-0 pb-0 bkg-grey rounded-3" >
					<div class="viewer-wrapper overflow-auto h-100 bkg-grey">
                        <div v-if="empty_viewer" class="empty-viewer bkg-grey ">
                            <img src="/assets/images/icons/template.svg" />
                            <h2>{{ $t("res_Msgs_NoTemplatesSelected") }}</h2>
                            <p>{{ $t("res_Msgs_SelectViewTemplate") }}</p>
                        </div>
                        <div id="choose_template_viewer_template "  style="height: calc(100vh - 280px) !important;">
                            <iframe :src="viewerFrameSrc" style="width: 100%; height: calc(100% )"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer sticky-footer top-shadow d-flex align-items-center justify-content-end position-relative">
            <v-btn color="light-blue" @click="closeSelectTemplatePopup()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
            <v-btn v-if="isDocument" class="primary" :disabled="selectedTemplateId === 0" @click="createByDocument()">{{
                $t("res_ButtonText_Continue") }}</v-btn>
            <v-btn v-else class="primary" :disabled="selectedTemplateId === 0" @click="createTemplate()">{{
                $t("res_ButtonText_Continue") }}</v-btn>
        </div>
    </div>
</template>

<script>
import { defaultGet, defaultPost } from '@/assets/js/common.js'
import constants from '@/assets/js/constants.js'
import axios from 'axios'
import MultiSelect from 'vue-multiselect'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'ChooseTemplate',
    components: { MultiSelect, VuePdfEmbed },
    props: {
        refreshToken: { type: String, default: '' },
        categoryType: { type: String, default: '' },
        dialogModelShow: { type: Boolean, default: false },
        linkedDocumentId:{type : Number, default : 0} 
    },
    data() {
        return {
            empty_viewer: true,
            loading: false,
            templateType: -1,
            templateTypes: [],
            signatureCount: -1,
            singatureCounts: [],
            language: -1,
            languages: [],
            privacy: -1,
            privacies: [],
            tag: -1,
            tags: [],

            search: '',
            templates: [],
            favourite_templates: [],
            favoriteCorrespondences: [],

            selectedTemplateId: 0,
            selectedTemplate: {},

            viewerFrameSrc: '',
            SearchLabel: '',
            filter_menu1: false,
            filter_menu2: false,
            filter_menu3: false,
            filter_menu4: false,
            filter_menu5: false,
            utils: utils,
            isDocument: false,
            documentId: 0,
            removeFavoriteDialog: false,
            lang: '',
            constants: constants
        };
    },
    watch:
    {
        refreshToken: function (newVal, oldVal) {
            if (newVal != '' && newVal != oldVal)
                this.clearAllFilters()
        },
        dialogModelShow(newVal, oldVal) {
            this.getFavoriteCorrespondences()
            this.clearAllFilters()
            if (newVal != oldVal) {
                if (newVal == true) { }
                else {
                    this.closeSelectTemplatePopup()
                }
            }
        },
    },
    mounted: function () {
        this.lang = localStorage.getItem('lang');
        this.getFavoriteCorrespondences();
        this.clearAllFilters()
        this.SearchLabel = window.translate("res_Label_SearchPlaceHolder")
    },
    methods:
    {
        chooseLanguageLabel(item) {
            if(this.lang == 'ar') {
                return item == 'EN' ? 'الانجليزية' : 'العربية';
            } else {
                return item == 'EN' ? 'English' : 'Arabic';
            }
        },
        chooseLanguageValue(item) {
            if(this.lang == 'ar') {
                return item == 'EN' ? 'الانجليزية' : 'العربية';
            } else {
                return item == 'EN' ? 'English' : 'Arabic';
            }
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
            else if (id === 3) this.$refs.multiselect3.activate()
            else if (id === 4) this.$refs.multiselect4.activate()
            else if (id === 5) this.$refs.multiselect5.activate()
        },
        scrollIntoViewer() {
            document.getElementById("choose_template_viewer_template").scrollIntoView()
        },
        getTemplateFiltersAndStatistics() 
        {
            let catType = this.categoryType
            if (catType == '') catType = '0'

            defaultGet('Template/GetTemplateFiltersAndStatistics?categoryId=' + catType, (res) => {
                if (res.data != null && res.data != undefined && res.data.length > 0) {
                    this.templateTypes = JSON.parse(res.data[0].templateTypes)
                    this.singatureCounts = JSON.parse(res.data[0].signatureCounts)
                    this.languages = JSON.parse(res.data[0].languages)
                    this.tags = JSON.parse(res.data[0].tags)
                    this.privacies = JSON.parse(res.data[0].privacies)
                }
            },
                this.handleError, true);
        },
        searchTemplates() {
            this.getTemplates()
        },
        searchByTemplateType() {
            this.filter_menu1 = false
            this.getTemplates()
        },
        clearByTemplateType() {
            this.templateType = -1
            this.searchByTemplateType()
        },
        searchTemplatesBySignatruesCount() {
            this.filter_menu3 = false
            this.getTemplates()
        },
        clearTemplatesBySignatruesCount() {
            this.signatureCount = -1
            this.searchTemplatesBySignatruesCount()
        },
        searchTemplatesByLanguage() {
            this.filter_menu2 = false
            this.getTemplates()
        },
        clearTemplatesByLanguage() {
            this.language = -1
            this.searchTemplatesByLanguage()
        },
        searchTemplatesByTags() {
            this.filter_menu4 = false
            this.getTemplates()
        },
        clearTemplatesByTags() {
            this.tag = -1
            this.searchTemplatesByTags()
        },
        searchTemplatesByPrivacy() {
            this.filter_menu5 = false
            this.getTemplates()
        },
        clearTemplatesByPrivacy() {
            this.privacy = -1
            this.searchTemplatesByPrivacy()
        },
        prepareRequestObject() {
            var requestObj = {}

            requestObj.Search = this.search

            if (this.templateType == null || this.templateType == undefined || this.templateType == -1) {
                if (this.categoryType == '')
                    requestObj.CategoryId = 0
                else
                    requestObj.CategoryId = this.categoryType
            }
            else
                requestObj.CategoryId = this.templateType

            if (this.language == null || this.language == undefined)
                requestObj.Language = ''
            else
                requestObj.Language = this.language

            if (this.signatureCount == null || this.signatureCount == undefined)
                requestObj.SignatureCount = 0
            else
                requestObj.SignatureCount = this.signatureCount

            if (this.tag == null || this.tag == undefined || this.tag == -1)
                requestObj.Tags = ''
            else
                requestObj.Tags = this.tag

            if (this.privacy == null || this.privacy == undefined || this.privacy == -1)
                requestObj.Privacy = -1
            else
                requestObj.Privacy = this.privacy

            return requestObj
        },
        getTemplates() 
        {
            var requestObj = this.prepareRequestObject()

            axios.post(constants.baseApiUrl + 'Template/SearchTemplates', requestObj, { headers: constants.headers })
                .then(res => 
                {
                    this.favourite_templates = [];
                    this.templates = [];
                    if (res.data != null && res.data != undefined) 
                    {
                        res.data.forEach(element => 
                        {
                            element.extraInfoCount = 0;
                            element.extraInfoText = '';
                            if (element.privacy)
                            {
                                element.extraInfoCount++;
                                element.privacyName = utils.getPrivacyName(element.privacy);
                            }
                            if (element.tags)
                                element.extraInfoCount++;

                            element.extraInfoText = [element.tags, element.privacyName].filter(item => item ).join(', ');

                            if (element.favoriteTemplate > 0)
                                this.favourite_templates.push(element)
                            else
                                this.templates.push(element)
                        })
                    }
                })
                .catch(err => this.handleError(err))
        },
        handleTemplateClicked(item, isDocument = false) 
        {
            this.isDocument = isDocument;
            if(isDocument){
                this.documentId = item.documentId
            }
            this.selectedTemplateId = item.id
            this.selectedTemplate = item
            this.empty_viewer = false

            window.setViewerData('','');
            this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId=' + this.selectedTemplateId +
                '&lang=' + this.$i18n.locale + '&defaultScale=page-width&pageMode=view' + '&r=' + new Date().getTime()
        },
        closeSelectTemplatePopup() {
            this.selectedTemplateId = 0
            this.viewerFrameSrc = "" 
            this.empty_viewer = true
            this.favoriteCorrespondences = []
            this.templates = []
            this.$emit('closeSelectTemplatePopup', 0)
        },
        addToFavorites(templateId) 
        {
            var user = JSON.parse(sessionStorage.getItem("user"));
            var body = { UserId: user.profile.Id, TemplateId: templateId, CreatedDate: new Date().toISOString()}

            axios.post(constants.baseApiUrl + 'Template/AddFavoriteTemplateFile', body, { headers: constants.headers })
                .then(res => this.searchTemplates())
                .catch(err => this.handleError(err))
        },
        RemoveFromFavorites(templateId) 
        {
            axios.get(constants.baseApiUrl + 'Template/DeleteFavoriteTemplateFile?templateId=' + templateId, { headers: constants.headers })
                .then(res => this.searchTemplates())
                .catch(err => this.handleError(err))
        },
        RemoveFromDocumentFavorites(documentId) 
        {
            axios.get(constants.baseApiUrl + 'Document/DeleteFavorite?documentId=' + documentId, { headers: constants.headers })
                .then((res) => {
                    this.removeFavoriteDialog = false;
                    this.getFavoriteCorrespondences()
                })
                .catch(err => this.handleError(err))
        },
        handleError(error) 
        {
            this.loading = false
            console.log(error)
        },
        createTemplate() 
        {
            this.viewerFrameSrc = ""; 
            this.empty_viewer = true;

            if (this.selectedTemplateId === 0)
                return;

            var signatoryList = ''

            var defaultFormData = '{"senderDesignatedPerson": "", "recipientDesignatedPerson": "", "translatedSubject": "", "keywords": "", "otherAttachments": "", '
            defaultFormData = defaultFormData + '"signers": "[' + signatoryList + ']", "templateId": ' + this.selectedTemplate.id + '}'

            var user = JSON.parse(sessionStorage.getItem("user"));

            var saveParams = {
                'CategoryId': this.selectedTemplate.categoryId,
                "TemplateId": this.selectedTemplate.id,
                'CreatedByStructureId': user.profile.StructureId,
                'formData': defaultFormData,
                'LinkedDocumentId' : this.linkedDocumentId
            };

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };

            window.showLoading()
            axios.post(constants.baseApiUrl + 'Document/Save', saveParams, { headers: headers })
                .then((response) => 
                {
                    if (response.status == 200) 
                    {
                        var documentId = response.data
                        this.$emit('closeSelectTemplatePopup', documentId)
                    }
                    else
                        alert(response.data.message)
                })
                .catch((err) => console.log(err))
                .finally(() => window.hideLoading())
        },
        getShortDescription(description) 
        {
            if (typeof (description) !== 'undefined' && description !== null) 
            {
                if (description.length > 100)
                    return description.substring(0, 100) + '...'
                else
                    return description
            }
        },
        clearAllFilters() 
        {
            this.search = ''
            this.templateType = -1
            this.language = -1
            this.signatureCount = -1
            this.tag = -1
            this.privacy = -1
            this.viewerFrameSrc = ""
            this.getTemplateFiltersAndStatistics()
            this.searchTemplates()
        },
        clear() 
        {
            this.search = ''
            this.searchTemplates()
        },
        getFavoriteCorrespondences()
        {
            this.favoriteCorrespondences = []
            axios.get(constants.baseApiUrl + "Document/GetUserFavorites")
                .then((res)=>{
                    res.data.forEach(element => {
                    var favorite = { documentId: element.documentId, favoriteName: element.name, id: element.template.id, 
                    name: element.template.name, language: element.template.language, signatureCount: element.template.signatureCount,
                    descriptionAr: element.template.descriptionAr, descriptionEn: element.template.descriptionEn}
                    
                    this.favoriteCorrespondences.push(favorite);
                });
            })
            .catch(err => console.log(err));
        },
        createByDocument(){
            window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_copyLetterAlert'),
                    () => {
                        window.showLoading()
                        axios.post(constants.baseApiUrl + 'Document/CreateCopy?documentId=' + this.documentId)
                            .then(response => {
                                if (response.data != null) {
                                    var newDocumentId = response.data
                                    //close dialog
                                    this.viewerFrameSrc = ""; 
                                    this.empty_viewer = true;
                                    window.openNewCorrespondenceDialog(newDocumentId)
                                }
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
                    },
                    () => { });
        },
        openRemoveFavoriteDialog(){
            this.removeFavoriteDialog = true;
        }
    },
}
</script>

<style scoped>
    .template_filter_container { justify-content: space-between; align-items: flex-end; }
    .template_card:hover, .template_card:focus { background-color: #f1f8ff !important; }
    .template_selected { border: 1px solid #205cdf; }
    .template_card:hover .v-chip.purple, .template_card:focus .v-chip.purple { background: #fff !important; color: #5c068c !important; }
    .template_filter { flex: 1; }
    .filterPopup { min-width: 250px !important; }
</style>